import { SystemAuthorizations } from 'shell/authorizations/system';
import { HeadCell } from 'shell/components/shared/table/types';
import { NonRecoverableErrorsClient } from './types';
import * as yup from 'yup';

export const authsObj = Object.freeze({
  read: [SystemAuthorizations.ErrorQuery],
});

export const headCells: HeadCell<NonRecoverableErrorsClient, keyof NonRecoverableErrorsClient>[] = [
  {
    id: 'id',
    label: 'Id',
  },
  {
    id: 'dataTime',
    label: 'Data ora',
  },
  {
    id: 'operatorCode',
    label: 'Cod. Ope.',
  },
  {
    id: 'microService',
    label: 'Microservizio',
  },
  {
    id: 'api',
    label: 'API',
  },
  {
    id: 'action',
    label: '',
  },
];

export const validationSchemaNonRecoverableErrorsFilter = yup.object({
  id: yup.number(),
});
